import api from "../utils/apiServices";
import { decryptData, encryptData, signMd5 } from "../utils/secureUtils";
import AppData from "../config/appData.json";

export default async function handlePostApiCall(
  url,
  requestData,
  serialNumber
) {
  try {
    const encryptionKey = signMd5(`${AppData.CHANNEL_KEY}${serialNumber}`);
    // console.log("requestData", requestData);
    // Encrypt request data
    const encryptedData = encryptData(
      JSON.stringify(requestData),
      encryptionKey
    );

    const response = await api.post(url, { data: encryptedData });

    // Decrypt response data
    const decryptedData = decryptData(response.data, encryptionKey);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}
